import React from 'react';
import PropTypes from 'prop-types';
import GenericCheckBox from './GenericCheckBox';

const CheckboxList = ({
  options,
  allCheckboxTitle,
  updateList,
  unique,
  }) => {
  const onCheckBoxChange = (checkCode, isChecked) => {
    const isAllChecked = (checkCode === `all ${allCheckboxTitle}` && isChecked);
    const isAllUnChecked = (checkCode === `all ${allCheckboxTitle}` && !isChecked);
    const checked = isChecked ? 1 : 0;

    const updatedMediaList = options.map(item => {
      if (isAllChecked || item[unique] === checkCode) {
        return Object.assign({}, item, {
          s: checked,
        });
      } else if (isAllUnChecked) {
        return Object.assign({}, item, {
          s: 0,
        });
      }
      return item;
    });
    updateList(updatedMediaList);
  };

  const isAllSelected = () => {
    return options.filter(obj => obj.s === 0).length;
  };

  const checkBoxOptions = (
    <div className="checkbox-list">
      {options.map((option, index) => {
        return (
          <GenericCheckBox
            key={index}
            value={option[unique]}
            label={option.n}
            tick={option.s}
            onCheck={e => onCheckBoxChange(option[unique], e.target.checked)}
            testValue={`${option.c}${option.v ? option.v : ''}`}
          />
        );
      })}
    </div>
  );
  return (
    <div className="checkbox-group">
      <GenericCheckBox
        value={`all ${allCheckboxTitle}`}
        label={`All ${allCheckboxTitle}`}
        tick={isAllSelected() === 0}
        classname={(isAllSelected() === options.length || isAllSelected() === 0) ? 'default checkbox-grp' : 'indeterminate checkbox-grp'}
        onCheck={e => onCheckBoxChange(`all ${allCheckboxTitle}`, e.target.checked)}
      />
      {checkBoxOptions}
    </div>
  );
};

CheckboxList.propTypes = {
  options: PropTypes.instanceOf(Array),
  allCheckboxTitle: PropTypes.string,
  updateList: PropTypes.func,
  unique: PropTypes.string,
};

export default CheckboxList;
